export const baseStyles =
  'inline-flex items-center justify-center font-normal no-underline transition-colors duration-300 cursor-pointer disabled:pointer-events-none disabled:cursor-default aria-disabled:pointer-events-none aria-disabled:cursor-default';

export const buttonHeightStyles = {
  xs: 'h-8',
  s: 'h-12',
  m: 'h-8',
  l: 'h-8',
} as const;

export const buttonTextStyles = {
  xs: 'text-xs',
  s: 'text-sm',
  m: 'text-xs',
  l: 'text-xs',
} as const;

export const linkTextStyles = {
  xs: 'text-xs',
  s: 'text-sm',
  m: 'text-base',
  l: 'text-base',
} as const;

export const defaultPaddingStyles = {
  xs: 'px-4',
  s: 'px-6',
  m: 'px-4',
  l: 'px-4',
} as const;

export const iconOnlyPaddingStyles = {
  xs: 'px-2',
  s: 'px-4',
  m: 'px-2',
  l: 'px-2',
} as const;

export const linkIconGapStyles = {
  xs: 'gap-2',
  s: 'gap-2',
  m: 'gap-2.5',
  l: 'gap-3',
} as const;

const primaryDisabledStyles =
  'disabled:bg-velux-button-primary-disabled disabled:text-velux-grey-50 aria-disabled:bg-velux-button-primary-disabled aria-disabled:text-velux-grey-50';

const primaryDisabledDarkStyles =
  'disabled:bg-velux-button-primary-disabled-dark disabled:text-velux-grey-400 aria-disabled:bg-velux-button-primary-disabled-dark aria-disabled:text-velux-grey-400';

const secondaryDisabledStyles =
  'disabled:bg-transparent disabled:text-velux-button-secondary-disabled disabled:border-velux-button-secondary-disabled aria-disabled:bg-transparent aria-disabled:text-velux-button-secondary-disabled aria-disabled:border-velux-button-secondary-disabled';

const secondaryDisabledDarkStyles =
  'disabled:text-velux-button-secondary-disabled-dark disabled:border-velux-button-secondary-disabled-dark aria-disabled:text-velux-button-secondary-disabled-dark aria-disabled:border-velux-button-secondary-disabled-dark';

const linkDisabledStyles =
  'disabled:text-velux-button-tertiary-disabled aria-disabled:text-velux-button-tertiary-disabled';

const linkDisabledDarkStyles =
  'disabled:text-velux-button-tertiary-disabled-dark aria-disabled:text-velux-button-tertiary-disabled-dark';

export const variantStyles = {
  primary: {
    residential: `border-0 bg-velux-button-primary-initial text-velux-white [@media(hover:hover)]:hover:bg-velux-button-primary-hover ${primaryDisabledStyles}`,
    professionals: `border-0 bg-velux-red-900 text-velux-white [@media(hover:hover)]:hover:bg-velux-red-800 ${primaryDisabledStyles}`,
    commercial: `border-0 bg-velux-blue-800 text-velux-white [@media(hover:hover)]:hover:bg-velux-grey-900 ${primaryDisabledStyles}`,
    alternative: `border-0 bg-velux-green-600 text-velux-white [@media(hover:hover)]:hover:bg-velux-green-800 ${primaryDisabledStyles}`,
    onDark: `border-0 bg-velux-white text-velux-black [@media(hover:hover)]:hover:bg-velux-button-primary-hover-dark ${primaryDisabledDarkStyles}`,
  },
  secondary: {
    residential: `border border-velux-button-secondary-initial bg-transparent text-velux-button-secondary-initial [@media(hover:hover)]:hover:bg-velux-button-secondary-hover [@media(hover:hover)]:hover:border-transparent [@media(hover:hover)]:hover:text-velux-button-secondary-text-hover ${secondaryDisabledStyles}`,
    professionals: `border border-velux-black bg-transparent text-velux-black [@media(hover:hover)]:hover:bg-velux-grey-800 [@media(hover:hover)]:hover:border-transparent [@media(hover:hover)]:hover:text-velux-white ${secondaryDisabledStyles}`,
    commercial: `border border-velux-grey-900 bg-transparent text-velux-grey-900 [@media(hover:hover)]:hover:bg-velux-grey-900 [@media(hover:hover)]:hover:border-transparent [@media(hover:hover)]:hover:text-velux-white ${secondaryDisabledStyles}`,
    alternative: `border border-velux-black bg-transparent text-velux-black [@media(hover:hover)]:hover:bg-velux-black [@media(hover:hover)]:hover:border-transparent [@media(hover:hover)]:hover:text-velux-white ${secondaryDisabledStyles}`,
    onDark: `border border-velux-white bg-transparent text-velux-white [@media(hover:hover)]:hover:text-velux-black [@media(hover:hover)]:hover:bg-velux-button-secondary-hover-dark [@media(hover:hover)]:hover:border-transparent ${secondaryDisabledDarkStyles}`,
  },
  link: {
    residential: `border-0 bg-transparent text-velux-button-tertiary-initial [@media(hover:hover)]:hover:text-velux-button-tertiary-hover ${linkDisabledStyles}`,
    professionals: `border-0 bg-transparent text-velux-red-900 [@media(hover:hover)]:hover:text-velux-red-800 ${linkDisabledStyles}`,
    commercial: `border-0 bg-transparent text-velux-blue-800 [@media(hover:hover)]:hover:text-velux-blue-600 ${linkDisabledStyles}`,
    alternative: `border-0 bg-transparent text-velux-black [@media(hover:hover)]:hover:text-velux-button-alternative-hover ${linkDisabledStyles}`,
    onDark: `border-0 bg-transparent text-velux-white [@media(hover:hover)]:hover:text-velux-button-tertiary-hover-dark ${linkDisabledDarkStyles}`,
  },
} as const;

const defaultTypeIconNames = {
  page: 'direction-chevron-right',
  anchor: 'direction-arrow-down',
  drawer: 'math-symbols-plus',
} as const;

export const getDefaultTypeIconName = (type: string) =>
  defaultTypeIconNames[type as keyof typeof defaultTypeIconNames];

export const getIconSize = (
  iconSize: number | undefined,
  size: keyof typeof buttonTextStyles,
  hasDefaultTypeIcon: boolean,
  variant: keyof typeof variantStyles
) => {
  if (typeof iconSize === 'number' && iconSize > 0) {
    return iconSize;
  }

  if (variant === 'link') {
    if (hasDefaultTypeIcon) {
      return size === 'xs' || size === 's' ? 8 : 10;
    }

    return size === 'l' ? 24 : 16;
  }

  return 16;
};
